import { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { setStateURL, getTypedVal, setURL } from "../../utils/urls";

/**
 * Hook to manage app UI state: mobile menu and language.
 * Consolidates: useMobileMenu, useLanguage
 */
export function useAppUI() {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage;

  // Mobile menu state
  const [showMenu, setShowMenu] = useState(false);

  const openMenu = useCallback(() => setShowMenu(true), [setShowMenu]);
  const closeMenu = useCallback(() => setShowMenu(false), [setShowMenu]);
  const toggleMenu = useCallback(() => setShowMenu((prev) => !prev), [setShowMenu]);

  // Language
  const changeLanguage = useCallback(
    (lng: string) => {
      if (language !== lng) {
        setStateURL("lang_code", lng);
        i18n.changeLanguage(lng);
      }
    },
    [language]
  );

  // Initialize language from URL on mount
  useEffect(() => {
    if (!getTypedVal("htr_url_statefulurl")) {
      setURL("htr_url_statefulurl", true);
    }
    const langCode = getTypedVal("lang_code");
    if (langCode) changeLanguage(langCode);
  }, [changeLanguage, showMenu]);

  return {
    // Menu
    showMenu,
    setShowMenu,
    openMenu,
    closeMenu,
    toggleMenu,

    // Language
    language,
    changeLanguage,
  };
}
